export const ROUTES = {
  HELPCENTER: {
    path: "https://www.google.com/",
    label: "Help Center",
    target: "_blank", // Add target property
  },
  LEARN: {
    path: "/learn",
    label: "Learn",
  },
  FEES: {
    path: "/feesandlimits",
    label: "Fees & Limits",
  },
  TERMSOFUSE: {
    path: "/termsofuse",
    label: "Terms Of Use",
  },
  PRIVACYPOLICY: {
    path: "/privacypolicy",
    label: "Privacy Policy",
  },
  COMPANY: {
    path: "/company",
    label: "Company",
  },
  CAREER: {
    path: "/career",
    label: "Career",
  },
  ANNOUNCEMENTS: {
    path: "/announcements",
    label: "Announcements",
  },
  FEATURES: {
    path: "/features",
    label: "Features",
  },
  COOKIEPOLICY: {
    path: "/cookiepolicy",
    label: "Cookie Policy",
  },
  SECURITY: {
    path: "/security",
    label: "Security",
  },
  COMPLIANCEINFORMATION: {
    path: "/complianceinformation",
    label: "Compliance Information",
  },
  TRAVELRULE: {
    path: "/travelrule",
    label: "Travel Rule",
  },
};
